import React from 'react';
import { Link } from 'react-router-dom';
import pathObj from '../../services/Config';
import { UpdatedDecimalDigits } from '../../helpers/common';
import { formatPriceWithBreakdown } from '../../helpers/priceHelper';

const ProductGrid = ({
  products = [],
  loading = false,
  imageStatus = {},
  onProductClick = () => {},
  onGroupClick = () => {},
  wishlistStatus = {},
  handleWishlistToggle = () => {},
  quantities = {},
  handleQuantityChange = () => {},
  togglePriceDropdown = () => {},
  priceDropdownVisible = {},
  priceBreak = {},
  currencySymbol = '',
  handlePriceBreakdownClick = () => {},
  token = null,
  handleRatingChange = () => {},
  handleAddToCart = () => {},
  priceBreakDownloading = false,
}) => {
  if (loading) {
    return <div className="loader" />;
  }

  return (
    <div className="prd_grid">
      <ul>
        {products && products.length > 0 ? (
          products.map((product, index) => (
            <li key={index}>
              <div className="productThumb" onClick={() => product?.ProductType === 'single' ? onProductClick(product) : onGroupClick(product)}>
                {!imageStatus[product?.ItemCode] ? (
                  <div className="loader"></div>
                ) : (
                  <img src={imageStatus[product?.ItemCode] || product?.Picture || product?.vectorPicture || `${pathObj?.s3ImagePath}/no-image.jpg`} onError={(e) => { e.target.onerror = null; e.target.src = `${pathObj?.s3ImagePath}/no-image.jpg`; }} alt={product?.U_V33_WebProductName} />
                )}
              </div>

              <div className="productContent">
                <div className="instock_row">
                  {product?.ProductType === 'single' && (
                    <>
                      {product?.QuantityOnStock ? (
                        <div className="instock">
                          <img src={`${pathObj?.s3ImagePath}/instock-icon.svg`} alt="In Stock" /> In Stock
                        </div>
                      ) : (
                        <div className="outofstock">
                          <img src={`${pathObj?.s3ImagePath}/out-stock.svg`} alt="Currently not available" /> Currently not available
                        </div>
                      )}
                      {token && (
                        <div className="wishlist">
                          <img src={`${pathObj?.s3ImagePath}/wishlist-icon${wishlistStatus[product?.id] ? '-red' : ''}.svg`} alt="Wishlist Icon" onClick={() => handleWishlistToggle(product?.id)} style={{ cursor: 'pointer' }} />
                        </div>
                      )}
                    </>
                  )}
                </div>

                {(token && product?.ProductType === 'single') && (
                  <>
                    <div className="prd_rating">
                      {[1,2,3,4,5].map((rating) => {
                        const isFullStar = rating <= Math.floor(product?.rating);
                        const isHalfStar = rating > Math.floor(product?.rating) && rating < Math.ceil(product?.rating);
                        return (
                          <img key={rating} src={isFullStar ? `${pathObj?.s3ImagePath}/rating-icon.svg` : isHalfStar ? `${pathObj?.s3ImagePath}/half-rating-icon.svg` : `${pathObj?.s3ImagePath}/empty-rating-icon.svg`} alt={`${rating} stars`} onClick={() => handleRatingChange(product?.id, rating)} />
                        )
                      })}
                    </div>
                    <div className="prd_price">
                      <span className="old_price"></span>
                      <span className="special_price">
                        {formatPriceWithBreakdown({
                          currencySymbol,
                          csprice: product?.Csprice,
                          priceBreakdowns: priceBreak[product?.ItemCode],
                          minProductPrice: product?.MinProductPrice,
                          mainProductPrice: product?.MainProductPrice,
                          gbpPriceBreakdown: product?.GbpPriceBreakdown,
                          euroPriceBreakdown: product?.EuroPriceBreakdown
                        })}
                      </span>
                      { product?.GbpPriceBreakdown > 0 || product?.EuroPriceBreakdown > 0 ? <div className="priceBadge">Click to see price break</div> : ''}
                    </div>
                  </>
                )}

                {product?.ProductType === 'single' ? (
                  <>
                    <p style={{ cursor: 'pointer' }} onClick={() => onProductClick(product)}>{product?.ItemCode}</p>
                    <p onClick={() => onProductClick(product)} className="productNameStyle" title={product?.U_V33_WebProductName}>{product?.U_V33_WebProductName}</p>
                  </>
                ) : (
                  <>
                    <p onClick={() => onGroupClick(product)} className="productNameStyle" title={product?.U_V33_WebProductName}>{product?.U_V33_WebProductName}</p>
                  </>
                )}

                {token && product?.ProductType === 'single' ? (
                  <>
                    <div className="add_qty">
                      <div className="qty_plusminus" onClick={() => togglePriceDropdown(product?.ItemCode)} style={{ cursor: 'pointer' }}>
                        <button type="button" data-type="minus" onClick={() => handleQuantityChange(product?.ItemCode, 'minus')}>
                          <img src={`${pathObj?.s3ImagePath}/minus-icon.svg`} alt="" />
                        </button>
                        <input type="text" value={quantities[product?.ItemCode] || 1} onChange={(e) => handleQuantityChange(product?.ItemCode, 'input', e.target.value)} onClick={() => togglePriceDropdown(product?.ItemCode)} onFocus={(e) => e.target.select()} onKeyDown={(e) => { if (e.key === '-' || e.key === 'e') e.preventDefault(); }} />
                        <button type="button" data-type="plus" onClick={() => handleQuantityChange(product?.ItemCode, 'plus')}>
                          <img src={`${pathObj?.s3ImagePath}/plus-icon.svg`} alt="" />
                        </button>
                      </div>
                      <div className="add_btn">
                        <a href="#" className="button2" onClick={() => handleAddToCart(product)}>Add</a>
                      </div>
                    </div>

                    {priceBreakDownloading ? <div className="loader"></div> : null}
                    <div className="price_dropdow" style={{ display: priceDropdownVisible[product?.ItemCode] && priceBreak[product?.ItemCode]?.length > 0 ? 'block' : 'none' }}>
                      <div className="more_qty">
                        {priceBreak[product?.ItemCode]?.map((priceBreakdown) => (
                          <div className="more_qty_row" key={priceBreakdown.id} onClick={() => handlePriceBreakdownClick(product?.ItemCode, priceBreakdown?.Quantity, priceBreakdown?.price_break_down_id, priceBreakdown?.SpecialPrice)} style={{ cursor: 'pointer' }}>
                            <label>{priceBreakdown?.Quantity} qty</label>
                            <span>{currencySymbol}{UpdatedDecimalDigits(priceBreakdown?.SpecialPrice)}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                ) : (
                  product?.ProductType === 'single' ? (
                    <Link to="/login"><input className="button4" type="submit" value=" Login to see price" /></Link>
                  ) : (
                    <div className="view_variations_btn"><Link className="button4" to={`/group-products/${product?.ItemCode?.replace(/\//g, '__')}`}>View Variations</Link></div>
                  )
                )}
              </div>
            </li>
          ))
        ) : (
          <div className="notFound_record"><h4 className="not_found_category">No records found</h4></div>
        )}
      </ul>
    </div>
  )
}

export default ProductGrid;
